import { DealStates, ProjectStatus, ProjectStatusDisplay } from '~/constants';
import { Portfolio } from '~/types/portfolio';

export default function status(portfolio: Portfolio, portfolioState: any, permissions: any) {
  if (portfolio?.reactivatedPortfolio) {
    return 'Reactivated';
  }
  
  if (portfolio?.isArchived) {
    return 'Archived';
  }

  if (permissions.hasPortfolioInvestorAccess && !permissions.isAdmin) {
    switch (portfolioState.earliestState) {
      case DealStates.IN_DILIGENCE:
        return ProjectStatusDisplay.IN_DILIGENCE;
      case DealStates.EXECUTED:
        return ProjectStatusDisplay.EXECUTED;
      case DealStates.COMPLETED:
        return ProjectStatusDisplay.COMPLETED;
      case DealStates.DECLINED:
        return 'Projects declined';
      default:
        return 'Bidding';
    }
  } else {
    if (portfolioState.earliestState <= DealStates.READY_TO_SUBMIT) {
      return ProjectStatusDisplay[ProjectStatus.DRAFT];
    } else if (portfolioState.earliestState <= DealStates.MATCHING) {
      return ProjectStatusDisplay[ProjectStatus.IN_REVIEW];
    // } else if (portfolioState.earliestState === DealStates.DECLINED && portfolioState.latestState === DealStates.DECLINED) {
    //   return 'Projects Declined';
    } else if (portfolioState.earliestState <= DealStates.DECLINED) {
      return 'Bidding';
    } else if (portfolioState.earliestState === DealStates.IN_DILIGENCE) {
      return ProjectStatusDisplay[ProjectStatus.IN_DILIGENCE];
    } else if (portfolioState.earliestState === DealStates.EXECUTED) {
      return ProjectStatusDisplay[ProjectStatus.EXECUTED];
    } else {
      return ProjectStatusDisplay[ProjectStatus.COMPLETED];
    }
  } 
}
